<template >
  <div class="areaselect" v-if="areaselect.show">
    <div class="area-content">
      <div class="close-block" @click="getClose">
        <img src="/img/ui/close_gray.png" alt="">
      </div>
      <div class="ht">请选择所在州/市</div>
      <div class="area-item" v-if="arealist.length">
        <a href="javascript:;" :class="{ 'active': select.length && select[0].value == aitem.value }"
          @click="setAreaSelect(aitem, 1)" v-for="(aitem, index) in arealist[0].children"
          :key="'key-area-' + index">{{ aitem.label }}</a>
      </div>
      <div class="ht" v-if="select.length && areaselect.showchild">
        请选择所在区/县
      </div>
      <div class="area-item" v-if="select.length && areaselect.showchild">
        <a href="javascript:;" @click="setAreaSelect(item, 2)"
          :class="{ 'active': select.length && select[1] && select[1].value == item.value }"
          v-for="(item, index) in select[0].children" :key="'key-areaselect-' + index">
          {{ item.label }}
        </a>
      </div>
      <div class="btncancel">
        <button @click="getClose">取消</button>
      </div>
    </div>
    <div class="mask" @click="getClose"> </div>

  </div>
</template>
<script>
export default {
  /**
    * @property {Object} areaselect // {show：控制组件的显示，showchild：是否有二级分类}
    * @property {Array} arealist // 地区列表
    * @property {Array} select // 当前选中的地区
    * @property {Array} value // 要返回出去的当前选中的地区
    *
    */
  props: {
    areaselect: Object
  },
  data () {
    return {
      arealist: this.$store.state.device.areajson,
      select: [],
      value: []
    }
  },
  methods: {
    setAreaSelect (item, type) {
      if (type === 1) {
        // 一级分类
        this.value = [item, '']
        this.select = [item, '']
        if (!this.areaselect.showchild) {
          this.getClose()
          this.$emit('update', this.value)
        }
      }
      if (type === 2) {
        this.$set(this.select, 1, item)
        this.$set(this.value, 1, item)
        this.$emit('update', this.value)
        this.getClose()
      }
    },
    getClose () {
      this.select = []
      this.areaselect.show = false
      this.areaselect.showchild = false
      this.$emit('getClose', false)
    }
  }
}
</script>

<style lang="stylus" scoped>
.areaselect
  position fixed
  left 0
  right 0
  top 0
  bottom 0
  z-index 510
  .area-content
    position absolute
    top 40%
    padding 0.3rem
    left 50%
    background #fff
    width 12.4rem
    z-index 610
    background-color #ffffff
    border-radius 0.1rem
    transform translate(-50%, -50%)
    .ht
      text-align center
      font-size 0.3rem
      color #333333
      font-weight 600
      line-height 1
      padding 0.2rem 0 0.6rem 0
    .area-item
      display flex
      flex-wrap wrap
      margin-bottom 0.2rem
      a
        padding 0.05rem 0.24rem
        margin 0 0.1rem 0.2rem 0.1rem
        border-radius 0.06rem
        border solid 1px #ccc
        font-size 0.22rem
        color #333
        &.active
          background #3b6ae0
          color #fff
    .btncancel
      text-align center
      padding 0.3rem 0 0.2rem 0
      button
        width 2.03rem
        height 0.68rem
        background-color #3b6ae0
        border-radius 0.1rem
        font-size 0.28rem
        color #fff
        &:active
          background #2e5bcc
  .mask
    position absolute
    top 0
    bottom 0
    left 0
    right 0
    background rgba(0, 0, 0, 0.5)
    z-index 510
  .close-block
    position absolute
    top 0.2rem
    right 0.3rem
    width 0.4rem
    height 0.4rem
    text-align center
    z-index 510
    img
      width 0.3rem
</style>
